import { useTranslation } from "react-i18next";
import { useOnboardingWizard } from "../OnboardingWizardProvider";
import { Sparkles, ArrowRight } from "lucide-react";

export function SplashStep() {
  const { t } = useTranslation();
  const {
    stepConfig,
    goNext,
    executeAction,
    formData,
    markStepComplete,
    currentStep,
    onStepComplete,
  } = useOnboardingWizard();

  const handleNext = async () => {
    markStepComplete(currentStep);
    onStepComplete(currentStep);
    const result = await executeAction({ type: "completeStep" }, { formData });
    if (!result.serverAdvanced) goNext();
  };

  return (
    <div className="text-center space-y-8">
      {/* Hero icon */}
      <div className="mx-auto w-20 h-20 rounded-2xl bg-nara-orange/15 flex items-center justify-center">
        <Sparkles className="h-10 w-10 text-nara-orange" />
      </div>

      {/* Text */}
      <div className="space-y-3">
        <h1 className="text-3xl font-bold text-foreground">
          {t(stepConfig.title)}
        </h1>
        {stepConfig.subtitle && (
          <p className="text-lg text-muted-foreground">
            {t(stepConfig.subtitle)}
          </p>
        )}
      </div>

      {/* CTA */}
      <button
        onClick={handleNext}
        className="inline-flex items-center gap-2 px-8 py-4 bg-nara-orange text-nara-charcoal font-semibold rounded-xl hover:bg-nara-orange/90 transition-colors text-lg"
      >
        {t(stepConfig.nextLabel || "common.next")}
        <ArrowRight className="h-5 w-5" />
      </button>
    </div>
  );
}
